import { Fancybox } from '@fancyapps/ui';

document.addEventListener('DOMContentLoaded', () => {
  Fancybox.bind('[fancybox]', {});
  Fancybox.bind('[fancybox-group] a', {
    groupAll: true,
  });
});
